// extracted by mini-css-extract-plugin
export default {"noteRow":"SummaryPage_noteRow__2OOrW","note":"SummaryPage_note__4y+zM","noteTextArea":"SummaryPage_noteTextArea__+KZs8"};